import { ToastContainer } from 'react-toastify';

import { isRtlLocale, readStoredLocale } from '@/lib/locale';

import 'react-toastify/dist/ReactToastify.css';

export default function EmptyLayout({ children }: { children: React.ReactNode }) {
  const isRtl = isRtlLocale(readStoredLocale());

  return (
    <div className="from-primary to-secondary relative flex h-screen flex-col bg-gradient-to-bl">
      <main className="container mx-auto max-w-7xl flex-grow px-6 pt-16">{children}</main>
      <ToastContainer
        position={isRtl ? 'top-left' : 'top-right'}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={isRtl}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}
